// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".common-cls1___436d956d806ba6cd771{/*!*/}.common-cls2__c589224987ec8cad6f3f{}@media(max-width: 991px){.common-cls2__c589224987ec8cad6f3f{margin:16px 0 0 0;width:100%}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "common-cls1___436d956d806ba6cd771",
	"cls2": "common-cls2__c589224987ec8cad6f3f common-cls1___436d956d806ba6cd771"
};
export default ___CSS_LOADER_EXPORT___;
